import styled from "styled-components";
import { motion } from "motion/react";
import { useEffect, useState, useRef, Children, cloneElement } from "react";

export default function NavContainer({ children }) {
  const wrapperRef = useRef();
  const [maxHeight, setMaxHeight] = useState(0);

  const getMaxAccordionHeight = () => {
    let maxHeight = wrapperRef.current.getBoundingClientRect().height;
    const containerStyle = window.getComputedStyle(wrapperRef.current);
    const gapHeight = containerStyle.getPropertyValue("gap").replace("px", "");
    const gapPadding = 18;

    const containerChildren = [...wrapperRef.current.children];

    maxHeight = maxHeight - 36 * (containerChildren.length + 1);

    setMaxHeight(maxHeight);
  };

  useEffect(() => {
    getMaxAccordionHeight();
  }, []);

  return (
    <Wrapper
      initial="hidden"
      animate="show"
      variants={{
        hidden: {},
        show: {
          transition: {
            staggerChildren: 0.1,
            type: "spring",
          },
        },
      }}
      ref={wrapperRef}
    >
      {Children.map(children, (child) =>
        cloneElement(child, { maxOpenHeight: maxHeight })
      )}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  padding: 8px;
  padding: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  overflow: hidden;
  position: relative;
  z-index: 100;
  // justify-content: space-between;
`;
